import { forwardRef, ComponentPropsWithoutRef, ReactNode } from "react";
import clsx from "clsx";

const sizes = {
  xxs: "Xxs",
  xs: "Xs",
  s: "S",
  m: "M",
  l: "L",
  xl: "Xl",
  xxl: "Xxl",
};

type Sizes = typeof sizes;

type InsetProps = {
  /** Sets the size of the inset */
  size: keyof Sizes;
  /** Set to true to use a squash inset */
  squash?: boolean;
  /** Optional extra class(es) */
  className?: string;
  children: ReactNode;
} & ComponentPropsWithoutRef<"div">;

import styles from "./inset.module.scss";

const _Inset = forwardRef<HTMLDivElement, InsetProps>(
  ({ size = "m", squash, className, children, ...rest }, ref) => {
    const classes = [
      { [styles[`insetSq${sizes[size]}`]]: squash },
      { [styles[`inset${sizes[size]}`]]: !squash },
      className,
    ];

    return (
      <div {...rest} className={clsx(classes)} ref={ref}>
        {children}
      </div>
    );
  }
);

const Inset = Object.assign(_Inset, {
  sizes: Object.keys(sizes).reduce(
    (obj, key) => ({ ...obj, [key]: key }),
    {}
  ) as RecordKeys<Sizes>,
});

Inset.displayName = "Inset";

export default Inset;
